body = $('body');

body.on('change', '.LP_price_type_radio', function () {
    getLPPrice();
    chooseType();
});

body.on('change', '.LP_price_free', function () {
    getLPPrice()
});

function getLPPrice() {
    const priceInput = $('#price');
    const url = priceInput.attr('data-url');
    const method = priceInput.attr('data-method');
    const type = $('.LP_price_type_radio:checked').val();
    const freeSessions = $('.LP_price_free:checked').val();
    const partner = $('#partner').val();

    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {
            free_sessions: freeSessions,
            type: type,
            partner: partner
        },
        success: function (data) {
            if (data.status === 'success') {
                $('#price').val(data.price);

                $.each(data.priceTablesLP, function (i, priceTableLP) {
                    $('.LP_price_free[value="' + priceTableLP.free_sessions + '"]').parent()
                        .parent()
                        .find('.LP_price_description')
                        .html(priceTableLP.description);
                });
            }
        },
        error: function (err) {
            $('.ajaxFormError').remove();
            if (err.status == 422) { // when status code is 422, it's a validation issue

                $('#success_message').fadeIn().html(err.responseJSON.message);
                // display errors on each form field
                $.each(err.responseJSON.errors, function (i, error) {
                    var el = $(document).find('[name="' + i + '"]');
                    //el.after($('<div class="ajaxFormError mt-1 w-100 toast mb-2 d-flex align-items-center text-white bg-danger border-0" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body"><div class="d-flex align-items-center"><i class="fas fa-danger mr-1"></i>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</div></div></div>'));
                    el.after($('<div class="ajaxFormError alert alert-danger mt-2"><span class="svg-icon svg-icon-danger svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="black"/><rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="black"/><rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="black"/></svg></span><div class="d-flex flex-column"><h4 class="mb-1 text-dark">Alerta</h4><span>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</span></div></div>'));
                    //el.after($('<span class="alert-error">'+error[0].replace(i.replace('_', ' '), el.attr('data-title'))+'</span>'));
                });
            }
        },
        complete: function () {
            $('button[data-kt-indicator="on"]').removeAttr('data-kt-indicator');
        }
    });
}

function chooseType() {
    const type = $('.LP_price_type_radio:checked').val();
}
